import React from "react";
import styled from "styled-components";
import { Typography, Button, createMuiTheme } from "@material-ui/core";

export const Pane = styled.div`
    ${({ theme }) => `
        background-color: ${theme.palette.primary.light};
    `}
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 20rem;
`;
export const TimeDisplay = styled(props => (
    <Typography align="center" variant="h1" {...props} />
))`
    ${({ theme }) => `
        background-color: ${theme.palette.primary.light};
        color: white;
    `}
`;

export const ModeTab = styled.div`
  ${({theme}) => `
        background-color: ${theme.palette.primary.light};
        color: white;
  `}
  display: flex;
  justify-content: space-around;
  width: 100%;
  flex-direction: row;
  align-items: center;
`;

export const ActionButton = styled((props) => {
    return <Button {...props} variant="contained">{props.children}</Button>;
})`
    margin: 1rem;
    height: 3rem;
    width: 8rem;  
    ${({theme}) => `
        &:hover{
            background-color: ${theme.palette.primary.dark};
            color: white;
        }
        background-color: white;
        color: ${theme.palette.primary.main};
  `};
  
    
`;

export const ActionTab = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 2rem;
`;

export const todoTheme = createMuiTheme({
    palette: {
        primary: {
            main: "#B2C7B2",
            light: "#D5E2D5",
            dark: "#85A485",
        }
    }
});
export const doingTheme = createMuiTheme({
    palette: {
        primary: {
            main: "#778EC9",
            light: "#B1D1F6",
            dark: "#4E649D",
        }
    }
});
export const doneTheme = createMuiTheme({
    palette: {
        primary: {
            main: "#C67171",
            light: "#DD8F8F",
            dark: "#9D4B4B",
        }
    }
});